<template>
    <div class="modal fade" id="setor_search_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Filtrar</b>
                        </h5>
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">

                            <div class="form-group">
                                <label class="col-form-label">Nome:</label>
                                <input type="text" placeholder="Nome do Setor" v-model="nome_search" class="form-control">
                            </div>

                            <div class="form-group">
                                <label class="col-form-label" for="title">Unidade:</label>
                                <basic-select :options="unidades"
                                        :selected-option="unidade"
                                        placeholder="Selecione a Unidade"
                                        @select="onSelectUnidade">
                                </basic-select>
                            </div>

                        </div>

                    </div>
                    <div class="modal-footer">
                    	<div 
	                        v-if="(this.nome_search.length > 0 || 
	                        this.unidade_id_search > 0 )">
	                        <button type="button" @click.prevent.stop="limparFiltros" class="btn btn-danger pull-left">
	                            Limpar Filtros
	                        </button>
	                    </div>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success"
                            @click.prevent.stop="filterSetor">
                            Filtrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';
    import { TheMask } from 'vue-the-mask';
    import { BasicSelect } from 'vue-search-select';

    export default {

    	components: {
            Dot,
            TheMask,
            BasicSelect
        },


    	data(){
            return {
                configDateMask: {
                    maskedValue: false
                },
            	isLoading: false,

                //ARRAYS
            	filtros: [],
                unidades: [],

                //OBJECTS
                unidade: {},
                nome_search: '',
                unidade_id_search: null
            }
        },

        mounted(){
        	this.registryEventOpenModalSearchSetor();
        },

        methods: {
            registryEventOpenModalSearchSetor(){
                eventBus.$on('eventOpenModalSearchSetor', (filtrosParam) => {
                	this.filtros = filtrosParam;
                    this.checkClearFiltersForm();
                    this.getUnidades();
                    $("#setor_search_modal").modal("show");
                });
            },

            //EMIT EVENTS
            emitEventGetSetoresFilter(){
                eventBus.$emit('eventGetSetoresFilter', 
                    this.filtros
                );
            },
            //FIM EMIT EVENTS

            //OUTROS METODOS
            onSelectUnidade(item) {
                this.unidade = item;
                this.unidade_id_search = this.unidade.value;
            },
            //FIM OUTROS METODOS

            checkClearFiltersForm(){
                if(this.filtros.length == 0){
                    this.clearFiltros();
                }
            },

            clearFiltros(){
                this.filtros = [];
                this.unidade = {};
                this.nome_search = '';
                this.unidade_id_search = null;
            },

            limparFiltros(){
                this.clearFiltros();
                this.filterSetor();
            },

            //OUTROS METODOS
            onSelectMunicipio(item) {
                this.municipio = item;
                this.municipio_id_search = this.municipio.value;
            },
            //FIM OUTROS METODOS

            filterSetor(){
                this.filtros = [];
                
                if (this.nome_search.length > 0) {
                    this.filtros.push({ 
                        'property': 'nome',
                        'value': this.nome_search
                    });
                }

                if (this.unidade_id_search > 0) {
                    this.filtros.push({ 
                        'property': 'unidade_id',
                        'value': this.unidade_id_search
                    });
                }

                $("#setor_search_modal").modal("hide");
                this.emitEventGetSetoresFilter();
            },
            getUnidades(){

                var urlUnidades = '/unidade/combo';
                
                this.isLoading = true;
                
                axios({
                    method: 'GET',
                    url: urlUnidades
                })
                .then(response => {
                    let me = this;
                    this.isLoading = false;
                    this.unidades = [];
                    $.each(response.data, function (key, value) {
                        me.unidades.push({
                            'value': value.id,
                            'text': value.nome
                        });
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    toastr.error('Falha ao listar unidades');
                });
            },
        }
    }
</script>